/**
 * "Send waves" illustration for empty states (history without
 * transfers, etc.). Theme-aware: it is drawn in `currentColor`, so the
 * container decides the color (e.g. `text-accent`). Concentric waves with a
 * plane/arrow leaving — Enviar's motif, calm and premium.
 */

import type { Component } from "solid-js";

interface WaveIllustrationProps {
  class?: string;
}

export const WaveIllustration: Component<WaveIllustrationProps> = (props) => (
  <svg viewBox="0 0 120 120" fill="none" class={props.class} aria-hidden="true">
    {/* Ondas de señal irradiando desde el punto de origen */}
    <g stroke="currentColor" stroke-linecap="round" fill="none">
      <circle cx="60" cy="60" r="16" stroke-width="3" opacity="0.9" />
      <path d="M60 26a34 34 0 0 1 34 34" stroke-width="3" opacity="0.55" />
      <path d="M60 16a44 44 0 0 1 44 44" stroke-width="3" opacity="0.32" />
      <path d="M26 60a34 34 0 0 1 34 -34" stroke-width="3" opacity="0.55" />
      <path d="M16 60a44 44 0 0 1 44 -44" stroke-width="3" opacity="0.32" />
    </g>
    {/* Avión/flecha de envío en el centro */}
    <path
      d="M52 68 70 50 M62 50h8v8"
      stroke="currentColor"
      stroke-width="3.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
